import { SectionContent } from './SectionContent.style';

export default SectionContent;
